export const lineNetworkFragmentShader = `
uniform vec3 color;
uniform float opacity;
uniform float mode;

varying vec3 vColor;
varying float vOpacity;
varying float distToCamera;

void main() {
	float distMult = (vOpacity+0.25) * (30.0/distToCamera);
	if(mode == 1.0){
		distMult = 0.8 * opacity;
	}
	if(mode == 0.0){
		distMult = 0.8 * opacity;
	}
	if(mode == 2.0){
		distMult = 0.0;
	}
	
	gl_FragColor = vec4( vColor * color, ((opacity * vOpacity) + 0.05) * distMult );

}
`